import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1248b9e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body fadeIn" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "logo" }, "ArCode Gallery", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "more-results text-right"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 2,
  class: "loading text-center"
}
const _hoisted_7 = { key: 3 }
const _hoisted_8 = {
  key: 4,
  class: "text-center"
}
const _hoisted_9 = {
  key: 5,
  class: "more-results"
}
const _hoisted_10 = ["disabled"]

import CardList from '@/components/composed/CardList.vue'
import { onMounted, ref } from 'vue'
import { WorkspaceList } from '@/core/WorkspaceList'
import { ArweaveWrapper } from '@/core/ArweaveWrapper'
import { createToast } from 'mosha-vue-toastify'


export default /*#__PURE__*/_defineComponent({
  __name: 'GalleryPage',
  setup(__props) {

const elements = ref([])
const arweaveWrapper = new ArweaveWrapper()
const workspaceListClass = new WorkspaceList(arweaveWrapper.arweave)
const loading = ref(false)
const loadingMore = ref(false)
const showLoadMore = ref(false)
const disableGallery = ref(true)

const loadMore = async () => {
  loadingMore.value = true;
  try {
    const tmpRes = await workspaceListClass.nextResults()

    if (tmpRes && tmpRes.length) {
      showLoadMore.value = true
      elements.value.push(...tmpRes)
    } else {
      showLoadMore.value = false
    }
  } catch (error) {
    showLoadMore.value = false
    createToast(`${error}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      })
  }
  loadingMore.value = false;
}

onMounted(async () => {
  const limit = 5
  let maxHeight = 0
  loading.value = true
  try { 
    maxHeight = await arweaveWrapper.getCurrentHeight()
    elements.value = await workspaceListClass.getList(limit, maxHeight)

    if (elements.value && elements.value.length) {
      showLoadMore.value = true
    }
  } catch (error) {
    createToast(`${error}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      })
  }
  loading.value = false;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (disableGallery.value)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_3, "Coming soon ..."))
      : _createCommentVNode("", true),
    (!loading.value && !disableGallery.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
          _createElementVNode("a", {
            disabled: loadingMore.value,
            class: _normalizeClass({ btn: true, btnDisabled: loadingMore.value }),
            href: "/"
          }, " GO BACK TO ArCode ", 10, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    (loading.value && !disableGallery.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Loading ..."))
      : _createCommentVNode("", true),
    (elements.value.length)
      ? (_openBlock(), _createElementBlock("main", _hoisted_7, [
          _createVNode(CardList, { elements: elements.value }, null, 8, ["elements"])
        ]))
      : _createCommentVNode("", true),
    (!loading.value && (!elements.value || !elements.value.length))
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, " No results. "))
      : _createCommentVNode("", true),
    (!loading.value && showLoadMore.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
          _createElementVNode("button", {
            disabled: loadingMore.value,
            class: _normalizeClass({ btn: true, btnDisabled: loadingMore.value }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (loadMore()))
          }, " LOAD MORE RESULTS ", 10, _hoisted_10)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})